angular.module('cimerFrontEndApp').controller('CreateQuestionModalCtrl', ['$scope', '$uibModalInstance', 'directorID', 'TextEditorService', 'idFactory', function ($scope, $uibModalInstance, directorID, TextEditorService, idFactory) {

    "use strict";

    $scope.newQuestion = {};

    $scope.formOptions = {
        scaleLengthOptions: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
        questionTypes: [
            { name: 'Single-Select', id: 1 },
            { name: 'Text', id: 3 },
            { name: 'Matrix', id: 0 },
            { name: 'Multi-Select', id: 4 }
        ],
        questionType: null
    };
    $scope.temp = {};
    $scope.isCustom = directorID !== null;

    $scope.tinymceOptions = TextEditorService.GetTextEditorConfig();
    $scope.questionLabelMaxLength = 5000;
    $scope.questionPromptMaxLength = 5000;
    $scope.matrixQuestionPromptMaxLength = 5000;
    $scope.scaleAnswerMaxLength = 600;
    $scope.questionPromptLength = 0;
    $scope.matrixQuestionPromptLength = 0;
    $scope.scaleAnswerLengths = [];
    $scope.matrixIndividualQuestionPromptLengths = [];

    var isMatrix, isRadio, isMultipleChoice, isText;
    isMatrix = isRadio = isMultipleChoice = false;

    //if user changes question type we need to remove old state
    $scope.resetNewQuestion = function (questionType) {
        $scope.newQuestion = {};
        $scope.newQuestionForm.$setPristine();

        isMatrix = isRadio = isMultipleChoice = isText = false;
        switch (questionType.id) {
            case 0:
                isMatrix = true;
                break;
            case 1:
                isRadio = true;
                break;
            case 3:
                isText = true;
                break;
            case 4:
                isMultipleChoice = true;
                break;
        }

        //reset for all question types
        $scope.newQuestion.QuestionID = null;
        $scope.newQuestion.QuestionLabel = '';   //description of question
        $scope.newQuestion.QuestionRoleID = null;   // leave this up to the caller to determine
        $scope.newQuestion.SectionIndexID = null;  
        $scope.newQuestion.QuestionTypeID = questionType.id;
        $scope.newQuestion.QuestionType = questionType.name;
        $scope.newQuestion.Required = false;
        
        if (!isMatrix) {
            $scope.newQuestion.QuestionPromptID = 55; //not a matrix
            $scope.newQuestion.Text = ''; //actual question
            $scope.newQuestion.TextPlain = '';

            //matrices have answers attached to the matrix sub-questions
            $scope.newQuestion.Answer = ''; //for preview display only
            $scope.newQuestion.QuestionBranches = [];
        }

        if (isText) {
            $scope.newQuestion.QuestionScaleID = 4; //open-ended
            $scope.newQuestion.QuestionScale = []; //open-ended
        }
        else if (isMultipleChoice) {
            $scope.newQuestion.MultiSelectAnswers = {};
        }
        else if (!isMatrix) {
            $scope.newQuestion.QuestionScaleID = null;
            $scope.newQuestion.OwnerID = directorID;
        }
        else { //matrix
            $scope.newQuestion.QuestionPromptID = null;
            $scope.newQuestion.QuestionPromptText = '';
            $scope.newQuestion.Questions = [];
            //for added onto new matrix questions
            $scope.newQuestion.QuestionScaleID = null;
            $scope.newQuestion.OwnerID = null;

            $scope.addMatrixQuestion(); //need at least one question
        }
        $scope.formSubmitted = false; //reset this since we've reset everything else
        $scope.temp = {};
    };

    var resetMatrixScale = function () {
        for (var i = 0; i < $scope.newQuestion.Questions.length; i++) {
            $scope.newQuestion.Questions[i].QuestionScale = $scope.newQuestion.QuestionScale;
            $scope.newQuestion.Questions[i].QuestionScaleID = $scope.newQuestion.QuestionScaleID;
            $scope.newQuestion.Questions[i].OwnerID = $scope.newQuestion.OwnerID;
        }
    };

    //set newQuestion object if user changes the scale length
    $scope.setScaleLength = function () {
        $scope.newQuestion.QuestionScaleID = null;
        $scope.newQuestion.QuestionScale = [];
        $scope.newQuestion.OwnerID = directorID; //owned by creating user

        var i;
        $scope.scaleAnswerLengths = [];
        for (i = 0; i < $scope.temp.scaleLength; i++) {
            $scope.newQuestion.QuestionScale.push({
                AnswerNumber: i + 1,
                AnswerText: '',
                AnswerTextPlainText: '',
                ScaleAnswerID: null,
                NotApplicable: false,
                CompositeScoreRecodeValue: null,
                QuestionBranch: {
                    QuestionBranchID: null,
                    TempBranchID: null,
                    getID: function () { return this.QuestionBranchID || this.TempBranchID; }
                },
                tempID: idFactory.getNewScaleAnswerID(),
                getID: function () { return this.ScaleAnswerID || this.tempID; },
                IsOtherAnswer: false,
                OtherAnswerEnabled: true
            });
            $scope.scaleAnswerLengths[i] = 0;
        }
        //reset on all matrix questions
        if (isMatrix) { resetMatrixScale(); }
    };

    //add another question to the matrix
    $scope.addMatrixQuestion = function () {
        if (!$scope.newQuestion.hasOwnProperty('Questions') || $scope.newQuestion.Questions === undefined) {
            $scope.newQuestion.Questions = [];
        }
        var newQuestion = {
            QuestionID: null,
            QuestionPromptID: null,
            QuestionPromptText: $scope.newQuestion.QuestionPromptText,
            QuestionTypeID: 1, //Radio
            QuestionType: 'Single-Select', //radio
            Text: '',           //actual question
            QuestionScaleID: null,
            QuestionScale: $scope.newQuestion.QuestionScale,
            OwnerID: $scope.newQuestion.OwnerID,
            Answer: '', //for preview display only
            QuestionRoleID: null, // leave this up to the caller to determine
            SectionIndexID: null,
            QuestionBranches: [],
            Required: false // this isn't an option for matrix so default to false
        };
        $scope.newQuestion.Questions.push(newQuestion);
        $scope.matrixIndividualQuestionPromptLengths.push(0);
    };

    //remove this matrix question
    $scope.removeMatrixQuestion = function (index) {
        $scope.newQuestion.Questions.splice(index, 1);
        $scope.matrixIndividualQuestionPromptLengths.splice(index, 1);
    };
    $scope.updateMatrixPrompt = function () {
        for (var i = 0; i < $scope.newQuestion.Questions.length; i++) {
            $scope.newQuestion.Questions[i].QuestionPromptText = $scope.newQuestion.QuestionPromptText;
        }
    };
    //currently only called on matrix
    $scope.updateScaleText = function (index) {
        if (!isMatrix) { //only run for matrix
            return;
        }

        for (var i = 0; i < $scope.newQuestion.Questions.length; i++) {
            $scope.newQuestion.Questions[i].QuestionScale[index].AnswerText = $scope.newQuestion.QuestionScale[index].AnswerText;
            $scope.newQuestion.Questions[i].QuestionScale[index].AnswerTextPlainText = TextEditorService.ConvertToPlainTextSync($scope.newQuestion.QuestionScale[index].AnswerText);
        }
    };
    //currently only called on matrix
    $scope.updateNotApplicable = function (index) {
        if (!isMatrix) { //only run for matrix
            return;
        }

        for (var i = 0; i < $scope.newQuestion.Questions.length; i++) {
            $scope.newQuestion.Questions[i].QuestionScale[index].NotApplicable = $scope.newQuestion.QuestionScale[index].NotApplicable;
        }
    };
    //currently only called on matrix
    $scope.updateCompositeScoreRecodeValue = function (index) {
        if (!isMatrix) { //only run for matrix
            return;
        }

        for (var i = 0; i < $scope.newQuestion.Questions.length; i++) {
            $scope.newQuestion.Questions[i].QuestionScale[index].CompositeScoreRecodeValue = $scope.newQuestion.QuestionScale[index].CompositeScoreRecodeValue;
        }
    };
    $scope.updateIsOtherAnswer = function (index) {
        if (isMatrix) { // do not run for matrix, matrix cannot have other options
            return;
        }
        var isOtherAnswer = $scope.newQuestion.QuestionScale[index].IsOtherAnswer;
        for (var i = 0; i < $scope.newQuestion.QuestionScale.length; i++) {
            if (isOtherAnswer && index !== i) {
                $scope.newQuestion.QuestionScale[i].OtherAnswerEnabled = false;
            }
            else {
                $scope.newQuestion.QuestionScale[i].OtherAnswerEnabled = true;
            }
        }
    };

    $scope.formSubmitted = false;
    $scope.addQuestion = function () {
        $scope.formSubmitted = true;
        if (!$scope.newQuestionForm.$invalid) {
            // Update plain text
            if (!isMatrix) {
                $scope.newQuestion.TextPlain = TextEditorService.ConvertToPlainTextSync($scope.newQuestion.Text);
                for (var j = 0; j < $scope.newQuestion.QuestionScale.length; j++) {
                    $scope.newQuestion.QuestionScale[j].AnswerTextPlainText = TextEditorService.ConvertToPlainTextSync($scope.newQuestion.QuestionScale[j].AnswerText);
                }
            }
            else {
                $scope.newQuestion.QuestionPromptTextPlain = TextEditorService.ConvertToPlainTextSync($scope.newQuestion.QuestionPromptText);
            }
            // Assign temporary IDs
            if ($scope.newQuestion.QuestionTypeID === 0) { // matrix question
                for (var i = 0; i < $scope.newQuestion.Questions.length; i++) {
                    $scope.newQuestion.Questions[i].tempID = idFactory.getNewQuestionID();
                }
            }
            else {
                $scope.newQuestion.tempID = idFactory.getNewQuestionID();
            }

            $uibModalInstance.close($scope.newQuestion);
        }
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.checkQuestionPromptLength = function () {
        $scope.questionPromptLength = TextEditorService.GetPlainTextLength($scope.newQuestion.Text);
        $scope.updateValidity($scope.questionPromptLength, $scope.questionPromptMaxLength, $scope.newQuestionForm.questionForm.questionText, "questionText");
    };

    $scope.checkMatrixQuestionPromptLength = function () {
        $scope.matrixQuestionPromptLength = TextEditorService.GetPlainTextLength($scope.newQuestion.QuestionPromptText);
        $scope.updateValidity($scope.matrixQuestionPromptLength, $scope.matrixQuestionPromptMaxLength, $scope.newQuestionForm.questionForm.matrixQuestionText, "matrixQuestionText");
    };

    $scope.checkScaleAnswerLength = function (index) {
        $scope.scaleAnswerLengths[index] = TextEditorService.GetPlainTextLength($scope.newQuestion.QuestionScale[index].AnswerText);
        $scope.updateValidity($scope.scaleAnswerLengths[index], $scope.scaleAnswerMaxLength, $scope.newQuestionForm.questionForm.newScaleForm['scaleTextForm_' + index].text, "text");
    };

    $scope.checkMatrixIndividualQuestionPromptLength = function (index) {
        $scope.matrixIndividualQuestionPromptLengths[index] = TextEditorService.GetPlainTextLength($scope.newQuestion.Questions[index].Text);
        $scope.updateValidity($scope.matrixIndividualQuestionPromptLengths[index], $scope.questionPromptMaxLength, $scope.newQuestionForm.questionForm['matrixPromptForm_' + index].text, "text");
    };

    $scope.updateValidity = function (fieldLength, fieldMax, form, fieldName) {
        if (fieldLength > fieldMax) {
            form.$setValidity(fieldName, false);
        }
        else {
            form.$setValidity(fieldName, true);
        }
    };

}]);